import React, { Dispatch, SetStateAction, useState, useMemo } from "react"
import { get, find, includes, pick, chunk } from "lodash"

import { tableColumns } from "config/table_columns"
import { Panel } from "./index"
import { BaseTable } from "components/molecules/table"
import { Pagination } from "components/molecules/pagination"

import { APIResponse } from "redux/apis/types"
import { calledForeignData } from "components/actions/foreign"
import { PAGE_NUM } from "config/const"
import { ForeignTitle } from "components/templates/foreign"
import { CountryListType } from "components/pages/main/foreign"
import ClassNames from "classnames"
import { Labels } from "components/atoms/input/input"
import { SpDetailTable } from "components/molecules/table/spTable"
import { checkIsSp } from "utils/util"
import { BaseSelect } from "components/atoms/input/select"
import { Sort } from "utils/sort"
import store from "redux/store"
import { pageLoad } from "redux/ducks/PageLoad"

type indicatorItem = {
  data: Array<APIResponse.Res>
  changeData: Function
  selectDay: number
  changeDay: Function
  currentPage: number
  changePage: Function
}

type ForeignBasePanelType = {
  countryInfo: CountryListType
  filter: React.ReactElement
  templateType: string | number
  listData: calledForeignData
  symbolData: APIResponse.Res
  setSymbolData: Dispatch<SetStateAction<APIResponse.Res>>
  symbolList: APIResponse.Res
  currentSymbolPage: number
  symbolListChangePage: Function
  indicatorItem: indicatorItem
  selectList: number
  setSelectList: Function
}

export const ForeignBasePanel: React.FC<ForeignBasePanelType> = props => {
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])
  return (
    <Panel
      title={ForeignTitle(props.countryInfo.icon, props.countryInfo.name)}
      className={ClassNames("panel-summary-foreign", {
        summary: props.templateType === 0,
        list: props.templateType === 1,
      })}
      // refresh={() => store.dispatch(pageLoad())}
      filter={props.filter}
    >
      {props.templateType === 0 ? (
        <ForeignSummary
          listData={props.listData}
          symbolData={props.symbolData}
          setSymbolData={props.setSymbolData}
          indicatorItem={props.indicatorItem}
        />
      ) : !isPhone ? (
        <ForeignSymbolList
          list={props.symbolList}
          changePage={(n: number) => props.symbolListChangePage(n)}
          current={props.currentSymbolPage}
          setSymbolData={props.setSymbolData}
        />
      ) : (
        <>
          <BaseSelect
            option={props.countryInfo.selectList}
            value={props.selectList}
            onChange={(id: number) => props.setSelectList(id)}
          />
          <ForeignSymbolList
            list={props.symbolList}
            changePage={(n: number) => props.symbolListChangePage(n)}
            current={props.currentSymbolPage}
            setSymbolData={props.setSymbolData}
          />
        </>
      )}
    </Panel>
  )
}
const foreignIndexTableList = () => [
  {
    id: "index",
    name: "主要指数",
    security: 0,
    table: tableColumns.foreign.index,
  },
  {
    id: "exchange",
    name: "為替",
    security: 12000,
    table: tableColumns.foreign.currency,
  },
  {
    id: "interest",
    name: "主要金利",
    security: 13005,
    table: tableColumns.foreign.interest,
  },
  // {
  //   id: "todayIndex",
  //   name: "経済指標・本日発表",
  //   security: 9999,
  //   table: tableColumns.economics.domesticIndex("本日発表"),
  // },
  // {
  //   id: "pastIndex",
  //   name: "経済指標・過去7日",
  //   security: 9999,
  //   table: tableColumns.economics.domesticIndex("発表済"),
  // },
  // {
  //   id: "futureIndex",
  //   name: "経済指標・翌日以降",
  //   security: 9999,
  //   table: tableColumns.economics.domesticIndex("発表予定"),
  // },
]

const economicId = ["todayIndex", "pastIndex", "futureIndex"]

const label = [
  { id: 0, name: "本日発表" },
  { id: 1, name: "過去7日" },
  { id: 2, name: "翌日以降" },
]

type ForeignIndexTableType = {
  listData: calledForeignData
  setSymbolData?: Function
  symbolData?: APIResponse.Res
  indicatorItem?: indicatorItem
}
export const ForeignIndexTable: React.FC<ForeignIndexTableType> = props => {
  // const [viewType, setViewType] = useState<0 | 1 | 2>(0)
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])
  const _listData = useMemo(() => {
    // return !isPhone
    //   ? props.listData
    //   : pick(props.listData, ["index", "exchange", "interest"])
    return pick(props.listData, ["index", "exchange", "interest"])
  }, [props.listData])

  const chunkIndustryData: Array<Array<object>> = chunk(
    get(props.indicatorItem, "data"),
    PAGE_NUM.PAGE_10
  )
  return (
    <div className="split-col result-list-col result-tab-list-col">
      <div className="nano has-scrollbar">
        {!!props.listData
          ? Object.keys(props.listData).map((key: string, i: number) => {
              // ? Object.keys(_listData).map((key: string, i: number) => {
              const tableInfo = find(foreignIndexTableList(), {
                id: key,
              })
              return (
                <div key={i} className="list-block">
                  <div className="control-row filter-control-row sp">
                    <div className="title-border">{tableInfo.name}</div>
                  </div>
                  <BaseTable
                    key={i}
                    // className="table-list-view table-overseas-summary"
                    className={ClassNames(
                      "table-list-view table-overseas-summary table-liquid-cell",
                      {
                        "table-economic-indicator": includes(economicId, key),
                      }
                    )}
                    list={tableInfo.table}
                    data={get(props.listData, key + ".ResultList")}
                    onClick={(data: APIResponse.Res) => {
                      const _data = !isPhone ? data : { ...data }
                      props.setSymbolData && props.setSymbolData(_data)
                    }}
                  />
                </div>
              )
            })
          : null}
        {props.indicatorItem && (
          <div className="list-block list-fixed-height">
            <div className="control-row filter-control-row sp">
              <div className="title-border">経済指標</div>
              <div className="control-row panel-header-filter sp">
                <BaseSelect
                  option={Sort.EconomicForeignDate}
                  value={props.indicatorItem.selectDay}
                  onChange={(num: number) => {
                    props.indicatorItem.changeDay(num)
                    props.indicatorItem.changePage(0)
                  }}
                />
              </div>
            </div>
            <div className="result-list-block">
              {!isPhone ? (
                <>
                  <BaseTable
                    className="table-list-view table-liquid-cell table-economic-indicator"
                    list={tableColumns.economics.index}
                    data={chunkIndustryData[props.indicatorItem.currentPage]}
                    onClick={(data: APIResponse.Res) => {
                      props.setSymbolData && props.setSymbolData(data)
                    }}
                  />
                  <Pagination
                    list={props.indicatorItem.data}
                    current={props.indicatorItem.currentPage}
                    page={PAGE_NUM.PAGE_10}
                    changePage={props.indicatorItem.changePage}
                  />
                </>
              ) : (
                <SpDetailTable
                  headerList={tableColumns.economics.sp.header}
                  bodyList={tableColumns.economics.sp.body}
                  data={props.indicatorItem.data}
                  onClick={(data: object) => {
                    props.setSymbolData && props.setSymbolData({ ...data })
                  }}
                />
              )}
            </div>
          </div>
        )}
        {/*{isPhone && (*/}
        {/*  <div className="list-block">*/}
        {/*    <div className="control-row filter-control-row sp">*/}
        {/*      <div className="title-border">経済指標</div>*/}
        {/*    </div>*/}
        {/*    <Labels*/}
        {/*      className="btn-segmented-control btn-thin liquid-control filter-control-item"*/}
        {/*      labelList={label}*/}
        {/*      checked={viewType}*/}
        {/*      onChange={(id: 0 | 1 | 2) => {*/}
        {/*        setViewType(id)*/}
        {/*      }}*/}
        {/*    />*/}
        {/*    <SpDetailTable*/}
        {/*      headerList={tableColumns.economics.sp.header}*/}
        {/*      bodyList={tableColumns.economics.sp.body}*/}
        {/*      data={get(props.listData, economicId[viewType] + ".ResultList")}*/}
        {/*      onClick={(data: object) => {*/}
        {/*        const _data = !isPhone ? data : { ...data }*/}
        {/*        props.setSymbolData && props.setSymbolData(_data)*/}
        {/*      }}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*)}*/}
      </div>
    </div>
  )
}

type ForeignSummaryType = {
  listData: calledForeignData
  symbolData: APIResponse.Res
  setSymbolData: Dispatch<SetStateAction<APIResponse.Res>>
  indicatorItem: indicatorItem
}
export const ForeignSummary: React.FC<ForeignSummaryType> = props => {
  const symbolData = get(props.symbolData, "Symbol")
  return (
    <ForeignIndexTable
      listData={props.listData}
      setSymbolData={(data: APIResponse.Res) => props.setSymbolData(data)}
      symbolData={symbolData}
      indicatorItem={props.indicatorItem}
    />
  )
}

type ForeignSymbolListType = {
  list: APIResponse.Res
  current: number
  changePage: Function
  setSymbolData?: Function
}

export const ForeignSymbolList: React.FC<ForeignSymbolListType> = props => {
  const [currentPosition, changePosition] = useState<number>(0)
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])
  return (
    <>
      <BaseTable
        className="table-list-view table-striped table-summary-foreign"
        data={get(props.list, "ResultList", [])}
        list={
          !isPhone ? tableColumns.foreign.list : tableColumns.foreign.sp_list
        }
        active={currentPosition}
        onClick={(data: APIResponse.Res, i: number) => {
          const _data = !isPhone ? data : { ...data }
          props.setSymbolData && props.setSymbolData(_data)
          changePosition(i)
        }}
      />
      <Pagination
        total={get(props.list, "TotalCount")}
        list={get(props.list, "ResultList", [])}
        current={props.current}
        page={PAGE_NUM.PAGE_20}
        changePage={props.changePage}
      />
    </>
  )
}
